import { render, staticRenderFns } from "./NavSubMenu.vue?vue&type=template&id=568d3274&scoped=true&"
import script from "./NavSubMenu.vue?vue&type=script&lang=js&"
export * from "./NavSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavSubMenu.vue?vue&type=style&index=0&id=568d3274&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d3274",
  null
  
)

export default component.exports